// @libraries
import * as Yup from 'yup'

const degreeType = Yup.string().required('Degree type is required!')
const programType = Yup.string().required('Program type is required!')
const schoolName = Yup.string().required('School name is required!')
const graduationYear = Yup.string()
  .required('Graduation year is required!')
  .test('invalid-year', 'Invalid year', (value) => {
    if (typeof value === 'string' && !value.startsWith('0')) {
      if (value.length > 4) {
        return (
          new Date(value) > new Date(1900, 0, 0) &&
          new Date(value) < new Date(2040, 0, 0)
        )
      }
      if (value.length === 4) {
        return (
          new Date(parseInt(value), 0, 0) > new Date(1900, 0, 0) &&
          new Date(parseInt(value), 0, 0) < new Date(2040, 0, 0)
        )
      }
      return value.length > 3
    }
    return false
  })

const Education = Yup.array().of(
  Yup.object().shape({
    degreeType,
    programType,
    schoolName,
    graduationYear,
  }),
)

export const validationSchema = Yup.object().shape({
  Education,
})
